export enum AccessRightName {
	View = "view",
	Add = "add",
	Update = "update",
	Delete = "delete",
	Copy = "copy",
	Print = "print",
	Export = "export",
	Approve = "approve",
	StockReplenishment = "stock-replenishment",
	Convert = "convert",
	Drafting = "drafting",
	Signing = "signing",
	Report = "report",
}

export enum MenuName {
	Dashboard = "dashboard",
	Requisition = "requisition",
	Requisitions = "requisitions",
	SourcingBid = "sourcing-bid",
	Bids = "bids",
	MasterRecord = "master-record",
	Departments = "departments",
	Items = "items",
	Programmes = "programmes",
	EvaluationMethods = "evaluation-methods",
	SystemTemplates = "system-templates",
	TemplateTypes = "template-types",
	ProcurementMethods = "procurement-methods",
	UserManagement = "user-management",
	InternalUsers = "internal-users",
	Workflows = "workflows",
	RoleMenuAccessRights = "role-menu-access-rights",
	SBDDocuments = "sbd-documents",
	ContractSummaryGrid = "contract-summary-grid",
	PORequestSummaryGrid = "po-request-summary-grid",
	BidCommittee = "bid-committee",
	SystemScheduler = "system-scheduler",
	CSDIntegration = "csd-integration",
	Segments = "segments",
	Families = "families",
	Classes = "classes",
	Commodities = "commodities",
	Settings = "settings",
	SystemSetup = "system-setup",
	BudgetAllocationSummaryGrid = "budget-summary-grid",
	GlAccounts = "glAccounts",
	ErpDbCompanies = "erpDbCompanies",
	BudgetChangeOrders = "budget-change-orders",
	AdSync = "ad-sync",
	ProcureToPayDashboard = "procure-to-pay-dashboard",
	BudgetingProcessDashboard = "budgeting-process-dashboard",
	FinancialPerformanceDashboard = "financial-performance-dashboard",
	FixedAssetsTrackingDashboard = "fixed-assets-tracking-dashboard",
	SupplyChainManagementPortal = "supply-chain-management-portal",
	CompanyProfile = "company-profile",
	ExternalUsers = "external-users",
	ExpenditureSummaryGrid = "expenditure-summary-grid",
	ContractManagementDashboard = "contract-management-dashboard",
	PerformanceEvaluationSummaryGrid = "evaluation-summary-grid",
	PerformanceEvaluationDetail = "performance-evaluation-detail",
	PerformanceEvaluationHistoryDetail = "performance-evaluation-history-detail",
	InvoiceUploadSummaryGrid = "invoice-upload-summary-grid",
	ValidityPeriods = "validity-periods",
	Regions = "regions",
	SupplierBidSummary = "supplier-bid-summary-grid",
	AuditTrails = "audit-trails",
	VariationSummaryGrid = "variation-summary-grid",
	Divisions = "divisions",
	BidEvaluationGrid = "bid-evaluation",
	EvaluationCategories = "evaluation-category-summary-grid",
	PurchaseOrderSummaryGrid = "purchase-order-summary-grid",
	EvaluationElements = "evaluation-element-summary-grid",
	FinanceStatementDashboard = "finance-statement",
	CSDSupplierMaintenance = "csd-supplier-maintenance",
	CSDDailyUpdates = "csd-daily-updates",
	CSDRFQs = "csd-rfq",
	CSDDailyDetailedUpdate = "csd-daily-detailed-update",
	ContractCoordinator = "coordinators-summary-grid",
	ConsolidatedProcurementPlan = "consolidated-procurement-plan-sg",
	DepartmentalProcurementPlan = "departmental-procurement-plan-sg",
	QuerySummary = "query-summary-grid",
	PriceAndBeeSetting = "price-and-bee-settings-summary-grid",
	BidQueries = "bid-queries",
	PerformanceEvaluationSettings = "performance-evaluation-summary-grid",
	ContractManagementSettings = "contract-management-settings",
	ChangeOrderRequestSummaryGrid = "change-order-request-summary-grid",
	OrganisationalUnits = "organisational-structure",
	SubDivisions = "sub-divisions",
	SubRegions = "sub-regions",
	SubDepartments = "sub-departments",
	RequisitionSettings = "requisition-settings",
	SourcingSettings = "sourcing-settings",
	BudgetSummaryGridList = "budget-summary-grid-list",
	ProjectDetail = "project-detail",
	ProgrammeDetails = "programme-detail",
	ProjectSummaryGrid = "projects",
}
